let APIsList = [
  {
    title: "بهینه‌سازی مسیردهی",
    image: "tsp",
    url: "https://support.map.ir/developers/api/tsp/",
    demoUrl: '/service-detail/tsp/'
  },
  {
    title: "بهینه‌سازی ناوگان",
    image: "vrp",
    url: "https://support.map.ir/developers/api/vrp/",
    demoUrl: '/service-detail/vrp/'
  },
  {
    title: "تخمین زمان رسیدن",
    image: "eta",
    url: "https://support.map.ir/developers/api/eta/"
  },
  {
    title: "مسیریابی",
    image: "route",
    url: "https://support.map.ir/developers/api/route"
  },
  {
    title: "آدرس‌یابی پلاک‌دار",
    image: "reverse-pelak",
    url: "https://support.map.ir/developers/api/revpelak/"
  },
  {
    title: "حصار جغرافیایی",
    image: "geofence",
    url: "https://support.map.ir/developers/api/geofence/"
  },
  {
    title: "آدرس‌یابی",
    image: "reverse",
    url: "https://support.map.ir/developers/api/reverse/"
  },
  {
    title: "کروکی نقشه",
    image: "static-map",
    url: "https://support.map.ir/developers/api/static/"
  },
  {
    title: "جستجو",
    image: "search",
    url: "https://support.map.ir/developers/api/quest/"
  },
  {
    title: "ماتریس فاصله",
    image: "distance-matrix",
    url: "https://support.map.ir/developers/api/distance/"
  },
  {
    title: "نگاشت مختصات",
    image: "match",
    url: "https://support.map.ir/developers/api/match/"
  }
];

let servicesList = {
  "کسب‌و‌کار و تجارت": [
    {
      id: "taxi",
      title: "تاکسی اینترنتی",
      image: "demo-taxi",
      underConstruction: true
    },
    {
      id: "shop",
      title: "فروشگاه اینترنتی",
      image: "demo-shop",
      underConstruction: true
    },
    {
      id: "bank",
      title: "بانکداری",
      image: "demo-bank",
      underConstruction: true
    },
    {
      id: "tourism",
      title: "گردشگری",
      image: "demo-tourism",
      underConstruction: true
    }
  ],
  "سرویس‌ها": [
    // {
    //     title: 'نقشه پایه',
    //     image: ''
    // },
    {
      id: "tsp",
      title: "بهینه‌سازی مسیردهی",
      description:
        "اگر به دنبال این هستید که چگونه چندین مقصد را به بهینه‌ترین شیوه مرتب کنید تا مسیر عبور از تمامی مقصدها کوتاهترین و سریعترین مقصد باشد، راهکار بهینه‌سازی مسیردهی تمام آن چیزی است که به دنبالش هستید. این راهکار با استفاده از سرویس‌های مختلف مپ از جمله سرویس نقشه پایه، سرویس بهینه‌سازی مسیردهی، سرویس آدرس‌دهی پلاک‌دار و همچنین Web SDK مپ پیاده‌سازی شده است.",
      image: "demo-tsp",
      detailImage: "tsp-detail",
      underConstruction: false,
      intro: {
        "روش ورود اطلاعات": {
          type: "select",
          values: ["دستی"]
        },
        "روش انتخاب نقاط": {
          type: "select",
          values: ["انتخاب روی نقشه", "وارد کردن مختصات جغرافیایی"]
        },
        "کلید دسترسی": {
          type: "input"
        }
      }
    },
    {
      id: "search",
      title: "جستجو",
      image: "demo-search",
      underConstruction: true
    },
    {
      id: "vrp",
      title: "بهینه‌سازی ناوگان",
      description:
        "اگر به دنبال این هستید که چگونه چندین مقصد را به بهینه‌ترین شیوه مرتب کنید تا مسیر عبور از تمامی مقصدها کوتاهترین و سریعترین مقصد باشد، راهکار بهینه‌سازی مسیردهی تمام آن چیزی است که به دنبالش هستید. این راهکار با استفاده از سرویس‌های مختلف مپ از جمله سرویس نقشه پایه، سرویس بهینه‌سازی مسیردهی، سرویس آدرس‌دهی پلاک‌دار و همچنین Web SDK مپ پیاده‌سازی شده است.",
      image: "demo-vrp",
      detailImage: "vrp-detail",
      underConstruction: false,
      data: {
        vehicles: {
          "موتورسیکلت": {count: 10, capacity: [1]},
          "وانت سبک": {count: 5, capacity: [15]},
          "وانت نیسان": {count: 5, capacity: [20]},
          "کامیونت": {count: 5, capacity: [35]},
          "کامیون": {count: 2, capacity: [50]},
        }
      }
    }
  ]
};

const getDemoById = demoName => {
  let demo;
  for (let i in servicesList) {
    demo = servicesList[i].filter(item => item.id === demoName)[0];
    if (demo) break;
  }

  return demo;
};

export { APIsList, servicesList, getDemoById };
